export default __webpack_public_path__ + "static/media/a017-c.f5bb9c8b.svg";